import { ButtonGroup } from 'react-bootstrap'
import { Button, TextField } from '@mui/material'

import { IEvaluacion, IPesoPorcentaje } from '../constants';


interface Props {
  dataEvaluacion: IEvaluacion | IPesoPorcentaje;
  handleChange(type: string, value: string | number): void;
}

const PesoEvaluacion = ({ dataEvaluacion, handleChange } : Props) => {
  return (
    <section className="flex flex-col justify-center gap-2">

      <div className="text-center mt-0">
        <br />
        <h5 className='font-bold mb-2'>¿Cuánto pesas actualmente?</h5>
      </div>

      <div className="flex gap-2 self-center">


        <TextField
          label="Peso"
          required
          type="number"
          autoComplete='Off'
          inputProps={{min: 0}}
          onChange={(e) => handleChange('peso', e.target.value)}
          />
        <ButtonGroup>
          <Button
            onClick={() => handleChange('unidadPeso', 'Kg')}
            variant={dataEvaluacion.unidadPeso === 'Kg' ? 'contained' : 'outlined'}
            style={{
              color: dataEvaluacion.unidadPeso === 'Kg' ? '' : '#FDBA29',
              backgroundColor: dataEvaluacion.unidadPeso === 'Kg' ? '#FDBA29' : '',
              border: dataEvaluacion.unidadPeso === 'Kg' ? '' : '1px solid #FDBA29',
            }}
            >
            Kg
          </Button>
          <Button
            onClick={() => handleChange('unidadPeso', 'Lb')}
            variant={dataEvaluacion.unidadPeso === 'Lb' ? 'contained' : 'outlined'}
            style={{
              color: dataEvaluacion.unidadPeso === 'Lb' ? '' : '#FDBA29',
              backgroundColor: dataEvaluacion.unidadPeso === 'Lb' ? '#FDBA29' : '',
              border: dataEvaluacion.unidadPeso === 'Lb' ? '' : '1px solid #FDBA29',
            }}
          >
            Lb
          </Button>
        </ButtonGroup>
      </div>
    </section>
  )
}

export default PesoEvaluacion